import apiClient from '../apiClient';

const interviewService = {
    // Get all interviews
    getInterviews: async (params = {}) => {
        try {


            const response = await apiClient.get('/recruitment/interviews', { params });

            return response;
        } catch (error) {


            // Return structured error response
            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to fetch interviews',
                error: error.response?.data?.error || error.message,
                data: null
            };
        }
    },

    // Get interview by ID
    getInterviewById: async (id) => {
        try {


            const response = await apiClient.get(`/recruitment/interviews/${id}`);

            return response;
        } catch (error) {


            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to fetch interview',
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Schedule new interview
    scheduleInterview: async (interviewData) => {
        try {


            const response = await apiClient.post('/recruitment/interviews', interviewData);

            return response;
        } catch (error) {


            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to schedule interview',
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Update interview
    updateInterview: async (id, interviewData) => {
        try {


            const response = await apiClient.put(`/recruitment/interviews/${id}`, interviewData);

            return response;
        } catch (error) {


            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to update interview',
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Delete interview
    deleteInterview: async (id) => {
        try {


            const response = await apiClient.delete(`/recruitment/interviews/${id}`);

            return response;
        } catch (error) {


            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to delete interview',
                error: error.response?.data?.error || error.message,
                data: null
            };
        }
    },

    // Update interview status
    updateInterviewStatus: async (id, status, additionalData = {}) => {
        try {


            const response = await apiClient.put(`/recruitment/interviews/${id}/status`, {
                status,
                ...additionalData
            });

            return response;
        } catch (error) {


            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to update interview status',
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Export interviews
    exportInterviews: async (filters = {}) => {
        try {


            const token = localStorage.getItem('auth_token');
            const { API_BASE_URL } = await import('../config');
            const axios = (await import('axios')).default;

            const response = await axios.post(`${API_BASE_URL}/recruitment/interviews/export`, filters, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            return response.data;
        } catch (error) {

            throw error;
        }
    },

    // Send interview reminder
    sendInterviewReminder: async (id) => {
        try {

            const response = await apiClient.post(`/recruitment/interviews/${id}/reminder`);

            return response;
        } catch (error) {

            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to send reminder',
                error: error.response?.data?.error || error.message
            };
        }
    },
    // Get interview round types
    getInterviewRounds: async () => {
        try {
            const response = await apiClient.get('/config/interview-rounds');
            return response;
        } catch (error) {
            return {
                success: false,
                responseCode: error.response?.status || 500,
                responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to fetch interview rounds',
                error: error.response?.data?.error || error.message
            };
        }
    }
};

export default interviewService;
